import { useState } from 'react'
import { Formik } from 'formik'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import NumberInput from 'components/Inputs/NumberInput'
import MoneyInput from 'components/Inputs/MoneyInput'
import Select from 'components/Inputs/Select'
import MainButton from 'components/Buttons/MainButton'
import tipValidator from 'validators/tipValidator'
import { FaTimes } from 'react-icons/fa'

import {
  Form,
  FormField,
  CloseButton,
  FieldGrid,
  Row,
  InfoText,
  Label,
  Input,
  WarningText,
  ErrorContainer
} from './styles'

export default function BillTipForm ({
  bill,
  professionals = [],
  defaultProfessional = null,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Formik
      validationSchema={tipValidator}
      initialValues={{
        'professional': defaultProfessional,
        'description': '',
        'value': 0,
        'comission_percentage': 100
      }}
      onSubmit={async (values, { setSubmitting }) => {
        const tipData = {
          billId: bill.id,
          professionalId: values.professional.value,
          description: values.description,
          value: values.value,
          comissionPercentage: values.comission_percentage / 100
        }

        try {
          const { data: tip } = await cutileiApi.post ('/tips', tipData, requestConfig)

          setSubmitting (false)
          handleConfirm (tip)
          handleClose ()
        } catch (error) {
          setErrorMessage (getApiErrorMessage (error))
          setSubmitting (false)
          logApiError (error)
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form>
          <FieldGrid>
            <FormField>
              {touched.professional && errors.professional && (
                <WarningText>
                  {errors.professional}
                </WarningText>
              )}
              <Select
                name='professional'
                placeholder='Profissional...'
                value={values.professional}
                options={professionals.map (professional => ({
                  label: professional.nickname, value: professional.id
                }))}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                error={errors.professional}
                touched={touched.professional}
              />
            </FormField>
            <FormField>
              <Input
                type='text'
                name='description'
                placeholder='Descrição'
                value={values.description}
                onChange={handleChange ('description')}
                onBlur={handleBlur ('description')}
              />
            </FormField>
            <FormField>
              <Label htmlFor='tip_value'>
                Valor
              </Label>
              <MoneyInput
                id='tip_value'
                name='value'
                placeholder='Valor'
                value={values.value}
                onValueChange={setFieldValue}
                onBlur={handleBlur ('value')}
              />
            </FormField>
            <FormField>
              <Label htmlFor='tip_comission_percentage'>
                Comissão (%)
              </Label>
              <NumberInput
                id='tip_comission_percentage'
                name='comission_percentage'
                value={values.comission_percentage}
                minValue={0}
                maxValue={100}
                onChange={setFieldValue}
                style={{width: '100%'}}
              />
            </FormField>
            <MainButton
              label='Adicionar'
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
              width={110}
            />
            <CloseButton onClick={handleClose}>
              <FaTimes color='#FF3939' size={18}/>
            </CloseButton>
          </FieldGrid>
          <Row>
            {errorMessage && (
              <ErrorContainer>
                <InfoText>{errorMessage}</InfoText>
              </ErrorContainer>
            )}
          </Row>
        </Form>
      )}
    </Formik>
  )
}
